import axios from "axios";
import {urlConfig} from "../config";


const contextServiceInstance = axios.create({baseURL: `${urlConfig.bffUrl}`});

export default class ContextService {

    static getContextLanguages() {
        return contextServiceInstance.get("/configs/languages?active=true");
    }

}